export default __webpack_public_path__ + "static/media/BrainBreak cards83.47f6af83.png";